import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Tag } from 'antd';
import { getServiceEntryByDomain } from '../../../apis/serviceEntry';
import AdminLayoutWrapper from '../AdminLayoutWrapper';

const columns = [
  {
    title: 'Service Name',
    dataIndex: 'name',
    key: 'name',
    render: (value, record) => {
      return <Link to={`/admin/services/${record.id}`}>{value}</Link>
    }
  },
  {
    title: 'Group',
    dataIndex: 'domain_group',
    key: 'group',
    render: (value) => {
      return <Tag color='blue'>{(value && value.toLowerCase()) || ''}</Tag>
    }
  },
  {
    title: 'Updated At',
    dataIndex: 'updated_at',
    key: 'updated',
    render: (value) => {
      // return <p>{format(parseISO(value), 'Pp')}</p>
      return <p>{value}</p>
    }
  },
  // {
  //   title: 'Status',
  //   dataIndex: 'public',
  //   key: 'public',
  //   render: (value) => {
  //     return <Tag color={value ? 'green' : 'red'}>{value ? 'Public' : 'Private'}</Tag>
  //   }
  // },
  {
    title: 'Action',
    dataIndex: 'id',
    key: 'id',
    render: (value, record) => {
      return <Link to={`/admin/services/${record.id}`}><Button type="primary">Detail</Button></Link>
    }
  }
];


const ServiceEntryList = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    const fetchServiceEntry = async () => {
      try {
        const allServiceEntry = [];
        const { data } = await getServiceEntryByDomain();
        if (data && data.length > 0) {
          data.forEach(piece => {
            if (piece.service_entries && Array.isArray(piece.service_entries)) {
              allServiceEntry.push(...piece.service_entries);
            }
          });
          setServices(allServiceEntry)
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchServiceEntry()
  }, []);

  return (
    <AdminLayoutWrapper>
      <Table
         columns={columns}
         dataSource={services}
      />
    </AdminLayoutWrapper>
  )
}

export default ServiceEntryList;